import { render, staticRenderFns } from "./BetStatus.vue?vue&type=template&id=3ff6814e&"
import script from "./BetStatus.vue?vue&type=script&lang=js&"
export * from "./BetStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports